import { VisibilityMatrix, VisibilityMatrixAction, VisibilityMatrixFeature, VisibilityMatrixRole } from '@/types/Matrix';
import {
  CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, REPORTER, RD_COMMITTEE_COORDINATOR, CREATOR, CREATOR_JV, APPROVER, APPROVER_JV, ADMIN, CART_PLANT_SUPERVISOR,
  CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER,
  statusCampaign as statusCR, statusSubCampaign as statusSubCR, WORKFLOW_TYPE, CREATOR_EXTERNAL, VAN_COMMITTEE_COORDINATOR,
  VAN_E3_CAUSER, VAN_E3_CHIEF_ENGINEER_CARLINE, VAN_E2_QMB_APPROVER, VAN_CAMPAIGN_MANAGER, VAN_E3_QMB_PLANT_APPROVER, VAN_ROLES,
} from './constants';

const ALL_ROLES: VisibilityMatrixRole[] = [CREATOR, CREATOR_JV, CREATOR_EXTERNAL, REPORTER, RD_COMMITTEE_COORDINATOR, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
  ADMIN, CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, ...VAN_ROLES];

const matrix: VisibilityMatrix = {
  [VisibilityMatrixFeature.HEADER]: {
    [VisibilityMatrixAction.SEARCH]: ALL_ROLES,
    [VisibilityMatrixAction.PROFILE]: ALL_ROLES,
    [VisibilityMatrixAction.ALERT]: ALL_ROLES,
    [VisibilityMatrixAction.BURGER_MENU]: ALL_ROLES,
    [VisibilityMatrixAction.CART_LOGO]: ALL_ROLES,
  },
  [VisibilityMatrixFeature.SETTINGS]: {
    [VisibilityMatrixAction.SUPPORT]: ALL_ROLES,
  },
  [VisibilityMatrixFeature.LEFT_MENU]: {
    [VisibilityMatrixAction.CAMPAIGNS]: ALL_ROLES,
    [VisibilityMatrixAction.ADMINISTRATION]: [ADMIN],
  },
  [VisibilityMatrixFeature.CAMPAIGN_REQUEST]: {
    [VisibilityMatrixAction.EDIT_TITLE]: {
      [statusCR.IN_CREATION]: [CREATOR, CREATOR_JV, CREATOR_EXTERNAL, ADMIN, REPORTER, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_CAUSER_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN, REPORTER],
      [statusCR.IN_INFORMER_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN, REPORTER],
      [statusCR.IN_CAUSER_PRE_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN, REPORTER],
      [statusCR.IN_INFORMER_PRE_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN, REPORTER],
      [statusCR.IN_CAUSER_CHECK]: [CREATOR, CREATOR_JV, ADMIN, REPORTER],
      [statusCR.IN_INFORMER_CHECK]: [CREATOR, CREATOR_JV, ADMIN, REPORTER],
      [statusCR.IN_PLANT_VALIDATION]: [CREATOR, CREATOR_JV, ADMIN, REPORTER],
      [statusCR.IN_COMMITTEE]: [CREATOR, CREATOR_JV, ADMIN, REPORTER],
      [statusCR.IN_PLANT_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN, REPORTER],
      [statusCR.CLOSED]: [CREATOR, CREATOR_JV, REPORTER, ADMIN],
      [statusCR.COMPLETED]: [CREATOR, CREATOR_JV, REPORTER, ADMIN],
      [statusCR.DELETED]: [CREATOR, CREATOR_JV, REPORTER, ADMIN],
      [statusCR.REQUESTED_FOR_CHANGES]: [CREATOR, CREATOR_JV, REPORTER, ADMIN],
      [statusCR.IN_RD_COMMITTEE]: [CREATOR, CREATOR_JV, ADMIN, REPORTER, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_PREPARATION_FOR_REVIEW]: [ADMIN, REPORTER, CREATOR, CREATOR_JV],
      [statusCR.IN_REVIEW]: [ADMIN, REPORTER, CREATOR, CREATOR_JV],
      [statusCR.IN_VAN_CAUSER_APPROVAL]: [CREATOR, CREATOR_JV],
      [statusCR.IN_CARLINE_CONFIRMATION]: [CREATOR, CREATOR_JV],
      [statusCR.IN_QMB_VAN_INFORMATION]: [CREATOR, CREATOR_JV],
      [statusCR.IN_VAN_PLANT_VALIDATION]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_PLANT_IMPLEMENTATION]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_VAN_PLANT_IMPLEMENTATION]: [CREATOR, CREATOR_JV, ADMIN],
    },
    [VisibilityMatrixAction.DELETE]: {
      [statusCR.IN_CREATION]: [CREATOR, CREATOR_JV, CREATOR_EXTERNAL, ADMIN, REPORTER, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_CAUSER_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_INFORMER_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_CAUSER_PRE_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_INFORMER_PRE_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_CAUSER_CHECK]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_INFORMER_CHECK]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_PLANT_VALIDATION]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_COMMITTEE]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_PLANT_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.CLOSED]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.COMPLETED]: [CREATOR, CREATOR_JV, REPORTER, ADMIN],
      [statusCR.DELETED]: [CREATOR, CREATOR_JV, REPORTER, ADMIN],
      [statusCR.REQUESTED_FOR_CHANGES]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_RD_COMMITTEE]: [ADMIN, CREATOR, CREATOR_JV, REPORTER, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_PREPARATION_FOR_REVIEW]: [ADMIN, REPORTER, CREATOR, CREATOR_JV],
      [statusCR.IN_REVIEW]: [ADMIN, REPORTER, CREATOR, CREATOR_JV],
      [statusCR.IN_VAN_CAUSER_APPROVAL]: [CREATOR, CREATOR_JV],
      [statusCR.IN_CARLINE_CONFIRMATION]: [CREATOR, CREATOR_JV],
      [statusCR.IN_QMB_VAN_INFORMATION]: [CREATOR, CREATOR_JV],
      [statusCR.IN_VAN_PLANT_VALIDATION]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_PLANT_IMPLEMENTATION]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_VAN_PLANT_IMPLEMENTATION]: [CREATOR, CREATOR_JV, ADMIN],
    },
    [VisibilityMatrixAction.SHOW_SUMMARY]: {
      [statusCR.IN_CREATION]: [CREATOR, CREATOR_JV, CREATOR_EXTERNAL, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, ADMIN, REPORTER, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_CAUSER_APPROVAL]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_INFORMER_APPROVAL]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_CAUSER_PRE_APPROVAL]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_INFORMER_PRE_APPROVAL]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_CAUSER_CHECK]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_INFORMER_CHECK]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_PLANT_VALIDATION]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_COMMITTEE]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_PLANT_APPROVAL]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.DELETED]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.CLOSED]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.COMPLETED]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER, ...VAN_ROLES],
      [statusCR.REQUESTED_FOR_CHANGES]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_RD_COMMITTEE]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_PREPARATION_FOR_REVIEW]: [ADMIN, CREATOR, CREATOR_JV, REPORTER, ...VAN_ROLES],
      [statusCR.IN_REVIEW]: [ADMIN, CREATOR, CREATOR_JV, REPORTER, ...VAN_ROLES],
      [statusCR.IN_VAN_CAUSER_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, REPORTER, ...VAN_ROLES],
      [statusCR.IN_CARLINE_CONFIRMATION]: [ADMIN, CREATOR, CREATOR_JV, REPORTER, ...VAN_ROLES],
      [statusCR.IN_VAN_PLANT_VALIDATION]: [CREATOR, CREATOR_JV, ADMIN, REPORTER, ...VAN_ROLES],
      [statusCR.IN_QMB_VAN_INFORMATION]: [ADMIN, CREATOR, CREATOR_JV, REPORTER, ...VAN_ROLES],
      [statusCR.IN_PLANT_IMPLEMENTATION]: [CREATOR, CREATOR_JV, ADMIN, REPORTER],
      [statusCR.IN_VAN_PLANT_IMPLEMENTATION]: [CREATOR, CREATOR_JV, ADMIN, REPORTER, ...VAN_ROLES],
    },
    [VisibilityMatrixAction.FULL_CR]: {
      [statusCR.IN_CREATION]: [CREATOR, CREATOR_JV, CREATOR_EXTERNAL, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR, ADMIN, REPORTER,
        RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_CAUSER_APPROVAL]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_INFORMER_APPROVAL]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_CAUSER_PRE_APPROVAL]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_INFORMER_PRE_APPROVAL]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_CAUSER_CHECK]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_INFORMER_CHECK]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_PLANT_VALIDATION]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR, ADMIN,
        REPORTER, CENTER_VIEWER, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_COMMITTEE]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, REPORTER, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_PLANT_APPROVAL]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR, ADMIN,
        RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.DELETED]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.CLOSED]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.COMPLETED]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, REPORTER, CENTER_VIEWER, RD_COMMITTEE_COORDINATOR, REPORTER, ...VAN_ROLES],
      [statusCR.REQUESTED_FOR_CHANGES]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR,
        ADMIN, RD_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_RD_COMMITTEE]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, RD_COMMITTEE_COORDINATOR, CENTER_VIEWER, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, ADMIN, REPORTER],
      [statusCR.IN_PREPARATION_FOR_REVIEW]: [ADMIN, CREATOR, CREATOR_JV, REPORTER, ...VAN_ROLES],
      [statusCR.IN_REVIEW]: [ADMIN, CREATOR, CREATOR_JV, REPORTER, ...VAN_ROLES],
      [statusCR.IN_VAN_CAUSER_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, REPORTER, ...VAN_ROLES],
      [statusCR.IN_CARLINE_CONFIRMATION]: [ADMIN, CREATOR, CREATOR_JV, REPORTER, ...VAN_ROLES],
      [statusCR.IN_QMB_VAN_INFORMATION]: [ADMIN, CREATOR, CREATOR_JV, REPORTER, ...VAN_ROLES],
      [statusCR.IN_VAN_PLANT_VALIDATION]: [ADMIN, CREATOR, CREATOR_JV, ADMIN, ...VAN_ROLES],
      [statusCR.IN_PLANT_IMPLEMENTATION]: [CREATOR, CREATOR_JV, ADMIN, REPORTER],
      [statusCR.IN_VAN_PLANT_IMPLEMENTATION]: [CREATOR, CREATOR_JV, ADMIN, REPORTER, ...VAN_ROLES],
    },
    [VisibilityMatrixAction.SEND_TO_APPROVAL]: {
      [statusCR.IN_CREATION]: [CREATOR, CREATOR_JV, ADMIN, REPORTER],
    },
    [VisibilityMatrixAction.ASSIGN]: {
      [statusCR.IN_RD_COMMITTEE]: [RD_COMMITTEE_COORDINATOR],
    },
    [VisibilityMatrixAction.ASSIGN_TO]: {
      [statusCR.IN_PREPARATION_FOR_REVIEW]: [ADMIN, VAN_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_RD_COMMITTEE]: [RD_COMMITTEE_COORDINATOR],
    },
    [VisibilityMatrixAction.SEND_TO_REVIEW]: {
      [statusCR.IN_CREATION]: [CREATOR, CREATOR_JV, ADMIN, REPORTER],
      [statusCR.IN_PREPARATION_FOR_REVIEW]: [ADMIN, REPORTER],
      [statusCR.IN_REVIEW]: [ADMIN, REPORTER],
    },
    [VisibilityMatrixAction.SAVE]: {
      [statusCR.IN_CREATION]: [CREATOR, CREATOR_JV, CREATOR_EXTERNAL, ADMIN, REPORTER, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_CAUSER_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_INFORMER_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_CAUSER_PRE_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_INFORMER_PRE_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_CAUSER_CHECK]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_INFORMER_CHECK]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_PLANT_VALIDATION]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_COMMITTEE]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.IN_PLANT_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, REPORTER],
      [statusCR.CLOSED]: [CREATOR, CREATOR_JV, REPORTER, ADMIN],
      [statusCR.DELETED]: [CREATOR, CREATOR_JV, CREATOR_EXTERNAL, REPORTER, ADMIN],
      [statusCR.COMPLETED]: [CREATOR, CREATOR_JV, REPORTER, ADMIN],
      [statusCR.REQUESTED_FOR_CHANGES]: [CREATOR, CREATOR_JV, REPORTER, ADMIN],
      [statusCR.IN_RD_COMMITTEE]: [ADMIN, CREATOR, CREATOR_JV, REPORTER, RD_COMMITTEE_COORDINATOR],
    },
    [VisibilityMatrixAction.SHOW_CHANGES]: {
      [statusCR.IN_CREATION]: ALL_ROLES,
      [statusCR.IN_CAUSER_APPROVAL]: ALL_ROLES,
      [statusCR.IN_INFORMER_APPROVAL]: ALL_ROLES,
      [statusCR.IN_CAUSER_PRE_APPROVAL]: ALL_ROLES,
      [statusCR.IN_INFORMER_PRE_APPROVAL]: ALL_ROLES,
      [statusCR.IN_CAUSER_CHECK]: ALL_ROLES,
      [statusCR.IN_INFORMER_CHECK]: ALL_ROLES,
      [statusCR.IN_PLANT_VALIDATION]: ALL_ROLES,
      [statusCR.IN_COMMITTEE]: ALL_ROLES,
      [statusCR.IN_PLANT_APPROVAL]: ALL_ROLES,
      [statusCR.CLOSED]: ALL_ROLES,
      [statusCR.DELETED]: ALL_ROLES,
      [statusCR.COMPLETED]: ALL_ROLES,
      [statusCR.REQUESTED_FOR_CHANGES]: ALL_ROLES,
      [statusCR.IN_RD_COMMITTEE]: [ADMIN, RD_COMMITTEE_COORDINATOR, CREATOR, CREATOR_JV, REPORTER, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV,
        COMMITTEE_COORDINATOR, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV],
    },
    [VisibilityMatrixAction.MAKE_DECISION]: {
      [statusCR.IN_CAUSER_APPROVAL]: [APPROVER, APPROVER_JV, REPORTER],
      [statusCR.IN_INFORMER_APPROVAL]: [APPROVER, APPROVER_JV, REPORTER],
      [statusCR.IN_CAUSER_PRE_APPROVAL]: [APPROVER, APPROVER_JV, REPORTER],
      [statusCR.IN_INFORMER_PRE_APPROVAL]: [APPROVER, APPROVER_JV, REPORTER],
      [statusCR.IN_CAUSER_CHECK]: [CART_PLANT_SUPERVISOR, APPROVER, APPROVER_JV, REPORTER],
      [statusCR.IN_INFORMER_CHECK]: [CART_PLANT_SUPERVISOR, APPROVER, APPROVER_JV, REPORTER],
      [statusCR.IN_PLANT_VALIDATION]: [CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, APPROVER, APPROVER_JV, REPORTER],
      [statusCR.IN_COMMITTEE]: [CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, APPROVER, APPROVER_JV, REPORTER],
      [statusCR.IN_PLANT_APPROVAL]: [CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, APPROVER, APPROVER_JV, REPORTER],
      [statusCR.IN_RD_COMMITTEE]: [APPROVER, APPROVER_JV, REPORTER, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_REVIEW]: [ADMIN, VAN_COMMITTEE_COORDINATOR, REPORTER],
      [statusCR.IN_VAN_CAUSER_APPROVAL]: [VAN_E3_CAUSER],
      [statusCR.IN_CARLINE_CONFIRMATION]: [VAN_E3_CHIEF_ENGINEER_CARLINE],
    },
    [VisibilityMatrixAction.CONFIRM_KNOWLEDGE]: {
      [statusCR.IN_PLANT_VALIDATION]: [VAN_E2_QMB_APPROVER],
    },
    [VisibilityMatrixAction.CAMPAIGN_TABS]: {
      [statusCR.IN_CREATION]: [CREATOR, CREATOR_JV, CREATOR_EXTERNAL, ADMIN, CENTER_VIEWER, REPORTER, RD_COMMITTEE_COORDINATOR,
        CART_PLANT_SUPERVISOR],
      [statusCR.IN_CAUSER_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, REPORTER, CART_PLANT_SUPERVISOR,
        APPROVER, APPROVER_JV, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_INFORMER_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, REPORTER, CART_PLANT_SUPERVISOR,
        APPROVER, APPROVER_JV, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_CAUSER_PRE_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, REPORTER, CART_PLANT_SUPERVISOR,
        APPROVER, APPROVER_JV, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_INFORMER_PRE_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, REPORTER, CART_PLANT_SUPERVISOR,
        APPROVER, APPROVER_JV, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_CAUSER_CHECK]: [ADMIN, CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, REPORTER, CART_PLANT_SUPERVISOR,
        APPROVER, APPROVER_JV, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_INFORMER_CHECK]: [ADMIN, CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, REPORTER, CART_PLANT_SUPERVISOR,
        APPROVER, APPROVER_JV, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_PLANT_VALIDATION]: [ADMIN, CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, REPORTER, CART_PLANT_SUPERVISOR,
        APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, APPROVER, APPROVER_JV, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_COMMITTEE]: [ADMIN, CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, REPORTER, CART_PLANT_SUPERVISOR,
        APPROVER, APPROVER_JV, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_CARLINE_CONFIRMATION]: [ADMIN, REPORTER, ...VAN_ROLES],
      [statusCR.IN_PLANT_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, REPORTER,
        RD_COMMITTEE_COORDINATOR, CART_PLANT_SUPERVISOR, APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, APPROVER, APPROVER_JV],
      [statusCR.CLOSED]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, REPORTER,
        RD_COMMITTEE_COORDINATOR, CART_PLANT_SUPERVISOR, APPROVER, APPROVER_JV, ADMIN, REPORTER, ...VAN_ROLES],
      [statusCR.DELETED]: [CREATOR, CREATOR_JV, CREATOR_EXTERNAL, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, REPORTER,
        RD_COMMITTEE_COORDINATOR, CART_PLANT_SUPERVISOR, APPROVER, APPROVER_JV, ADMIN, REPORTER, ...VAN_ROLES],
      [statusCR.COMPLETED]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, REPORTER,
        RD_COMMITTEE_COORDINATOR, CART_PLANT_SUPERVISOR, APPROVER, APPROVER_JV, ADMIN, REPORTER, ...VAN_ROLES],
      [statusCR.REQUESTED_FOR_CHANGES]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, REPORTER,
        RD_COMMITTEE_COORDINATOR, CART_PLANT_SUPERVISOR, APPROVER, APPROVER_JV, ADMIN],
      [statusCR.IN_RD_COMMITTEE]: [ADMIN, CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, REPORTER, RD_COMMITTEE_COORDINATOR,
        CART_PLANT_SUPERVISOR, APPROVER, APPROVER_JV],
      [statusCR.IN_PREPARATION_FOR_REVIEW]: [ADMIN, CREATOR, CREATOR_JV, REPORTER, ...VAN_ROLES],
      [statusCR.IN_VAN_PLANT_VALIDATION]: [ADMIN, CREATOR, CREATOR_JV, REPORTER, ...VAN_ROLES],
      [statusCR.IN_PLANT_IMPLEMENTATION]: [CREATOR, CREATOR_JV, ADMIN, REPORTER],
      [statusCR.IN_VAN_PLANT_IMPLEMENTATION]: [CREATOR, CREATOR_JV, ADMIN, REPORTER],
      [statusCR.IN_REVIEW]: [ADMIN, CREATOR, CREATOR_JV, REPORTER, ...VAN_ROLES],
    },
    [VisibilityMatrixAction.TRANSLATIONS_TAB]: {
      [statusCR.IN_CREATION]: [CREATOR, CREATOR_JV, CREATOR_EXTERNAL, ADMIN, CENTER_VIEWER, REPORTER, RD_COMMITTEE_COORDINATOR],
    },
    [VisibilityMatrixAction.PLANT_FEEDBACK_TAB]: {
      [statusCR.IN_PLANT_VALIDATION]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, REPORTER, CART_PLANT_SUPERVISOR,
        APPROVER, APPROVER_JV, CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, APPROVER, APPROVER_JV, ADMIN],
    },
    [VisibilityMatrixAction.ASSIGN_CREATOR]: {
      [statusCR.IN_CREATION]: [CREATOR, CREATOR_JV, CREATOR_EXTERNAL, ADMIN],
    },
  },
  [VisibilityMatrixFeature.CAMPAIGN_OVERVIEW]: {
    [VisibilityMatrixAction.DELETE]: {
      [statusCR.IN_CREATION]: [CREATOR, CREATOR_JV, CREATOR_EXTERNAL, ADMIN],
      [statusCR.IN_CAUSER_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_INFORMER_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_CAUSER_PRE_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_INFORMER_PRE_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_CAUSER_CHECK]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_INFORMER_CHECK]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_PLANT_VALIDATION]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.CLOSED]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.COMPLETED]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.DELETED]: [CREATOR, CREATOR_JV, CREATOR_EXTERNAL, ADMIN],
      [statusCR.REQUESTED_FOR_CHANGES]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_RD_COMMITTEE]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_PREPARATION_FOR_REVIEW]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_REVIEW]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_VAN_CAUSER_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_CARLINE_CONFIRMATION]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_QMB_VAN_INFORMATION]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_VAN_PLANT_VALIDATION]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_PLANT_IMPLEMENTATION]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_VAN_PLANT_IMPLEMENTATION]: [CREATOR, CREATOR_JV, ADMIN],
    },
    [VisibilityMatrixAction.COPY]: {
      [statusCR.IN_CREATION]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_CAUSER_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_INFORMER_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_CAUSER_PRE_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_INFORMER_PRE_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_CAUSER_CHECK]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_INFORMER_CHECK]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_PLANT_VALIDATION]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_COMMITTEE]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_PLANT_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.CLOSED]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.COMPLETED]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.DELETED]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.REQUESTED_FOR_CHANGES]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_RD_COMMITTEE]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_PREPARATION_FOR_REVIEW]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_REVIEW]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_VAN_CAUSER_APPROVAL]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_CARLINE_CONFIRMATION]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_QMB_VAN_INFORMATION]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_VAN_PLANT_VALIDATION]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_PLANT_IMPLEMENTATION]: [CREATOR, CREATOR_JV, ADMIN],
      [statusCR.IN_VAN_PLANT_IMPLEMENTATION]: [CREATOR, CREATOR_JV, ADMIN],
    },
    [VisibilityMatrixAction.ASSIGN]: {
      [statusCR.IN_RD_COMMITTEE]: [RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_PREPARATION_FOR_REVIEW]: [ADMIN, VAN_COMMITTEE_COORDINATOR],
    },
    [VisibilityMatrixAction.ASSIGN_TO]: {
      [statusCR.IN_RD_COMMITTEE]: [ADMIN, RD_COMMITTEE_COORDINATOR],
      [statusCR.IN_PREPARATION_FOR_REVIEW]: [ADMIN, VAN_COMMITTEE_COORDINATOR],
    },
    [VisibilityMatrixAction.APPROVE_ALL_SUB_CRS_BY_CC]: {
      [statusCR.IN_PLANT_VALIDATION]: [COMMITTEE_COORDINATOR],
    },
    [VisibilityMatrixAction.MAKE_DECISSION_SUB_CRS_BY_CC]: {
      [statusCR.IN_PLANT_VALIDATION]: [COMMITTEE_COORDINATOR],
      [statusSubCR.IN_CONSOLIDATION]: [COMMITTEE_COORDINATOR],
      [statusSubCR.IN_PLANT_COORDINATION]: [COMMITTEE_COORDINATOR],
      [statusSubCR.PLANT_NOT_AFFECTED]: [COMMITTEE_COORDINATOR],
    },
  },
  [VisibilityMatrixFeature.SUB_CR]: {
    [VisibilityMatrixAction.COPY]: {
      [statusSubCR.IN_PLANT_PREPARATION]: [ADMIN, CREATOR, CREATOR_JV, VAN_CAMPAIGN_MANAGER],
      [statusSubCR.IN_PLANT_COORDINATION]: [ADMIN, CREATOR, CREATOR_JV],
      [statusSubCR.IN_VAN_PLANT_COORDINATION]: [ADMIN, CREATOR, CREATOR_JV, VAN_CAMPAIGN_MANAGER],
      [statusSubCR.DENIED]: [ADMIN, CREATOR, CREATOR_JV, VAN_CAMPAIGN_MANAGER],
    },
    [VisibilityMatrixAction.SHOW_SUMMARY_SUB_CR]: {
      [statusSubCR.OPEN]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, ADMIN],
      [statusSubCR.IN_CHECKING]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, ADMIN],
      [statusSubCR.IN_ANALYSIS]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, ADMIN],
      [statusSubCR.IN_CONSOLIDATION]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, ADMIN],
      [statusSubCR.IN_PLANT_COORDINATION]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, ADMIN],
      [statusSubCR.IN_E4_APPROVAL]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, ADMIN],
      [statusSubCR.IN_E3_APPROVAL]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, ADMIN],
      [statusSubCR.IN_PLANT_VALIDATION]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, ADMIN],
      [statusSubCR.ACCEPTED]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, ADMIN],
      [statusSubCR.DENIED]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, ADMIN, ...VAN_ROLES],
      [statusSubCR.IN_PLANT_COORDINATION]: [COMMITTEE_COORDINATOR, ADMIN],
      [statusSubCR.IN_VAN_PLANT_COORDINATION]: [VAN_COMMITTEE_COORDINATOR, ADMIN],
      [statusSubCR.IN_PLANT_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, ...VAN_ROLES],
      [statusSubCR.IN_PLANT_PREPARATION]: [ADMIN, CREATOR, CREATOR_JV, ...VAN_ROLES],
      [statusSubCR.IN_VAN_PLANT_COORDINATION]: [ADMIN, CREATOR, CREATOR_JV, ...VAN_ROLES],
    },
    [VisibilityMatrixAction.FULL_CR_SUB_CR]: {
      [statusSubCR.OPEN]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, ADMIN],
      [statusSubCR.IN_CHECKING]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, ADMIN],
      [statusSubCR.IN_ANALYSIS]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, ADMIN],
      [statusSubCR.IN_CONSOLIDATION]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, ADMIN],
      [statusSubCR.IN_PLANT_COORDINATION]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, ADMIN],
      [statusSubCR.IN_E4_APPROVAL]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, ADMIN],
      [statusSubCR.IN_E3_APPROVAL]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, ADMIN],
      [statusSubCR.IN_PLANT_VALIDATION]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, ADMIN],
      [statusSubCR.DENIED]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, ADMIN, ...VAN_ROLES],
      [statusSubCR.ACCEPTED]: [CREATOR, CREATOR_JV, COMMITTEE_COORDINATOR, CENTER_VIEWER, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, APPROVER, APPROVER_JV,
        CART_PLANT_SUPERVISOR, CART_PLANT_SUPERVISOR, CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV, ADMIN],
      [statusSubCR.IN_PLANT_COORDINATION]: [COMMITTEE_COORDINATOR, ADMIN],
      [statusSubCR.IN_PLANT_APPROVAL]: [ADMIN, CREATOR, CREATOR_JV, ...VAN_ROLES],
      [statusSubCR.IN_PLANT_PREPARATION]: [ADMIN, CREATOR, CREATOR_JV, ...VAN_ROLES],
      [statusSubCR.IN_VAN_PLANT_COORDINATION]: [ADMIN, CREATOR, CREATOR_JV, ...VAN_ROLES],
    },
    [VisibilityMatrixAction.MAKE_DECISION_SUB_CR]: {
      [WORKFLOW_TYPE.DIGITAL]: {
        [statusSubCR.IN_CHECKING]: [CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, ADMIN],
        [statusSubCR.IN_E3_APPROVAL]: [CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV],
      },
      [WORKFLOW_TYPE.NOT_READY]: {
        [statusSubCR.IN_ANALYSIS]: [CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, ADMIN],
        [statusSubCR.IN_E4_APPROVAL]: [CART_PLANT_SUPERVISOR],
        [statusSubCR.IN_E3_APPROVAL]: [CART_QMB_PLANT_APPROVER, QMB_PLANT_APPROVER_JV],
        [statusSubCR.IN_PLANT_APPROVAL]: [VAN_E3_QMB_PLANT_APPROVER],
      },
    },
    [VisibilityMatrixAction.SEND_TO_APPROVAL_SUB_CR]: {
      [WORKFLOW_TYPE.DIGITAL]: {
        [statusSubCR.IN_ANALYSIS]: [CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, ADMIN],
      },
    },
    [VisibilityMatrixAction.ASSIGN_MANAGER_OVERVIEW]: [CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, ADMIN, VAN_CAMPAIGN_MANAGER],
    [VisibilityMatrixAction.ASSIGN_MANAGER]: {
      [WORKFLOW_TYPE.DIGITAL]: {
        [statusSubCR.OPEN]: [CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, ADMIN],
        [statusSubCR.IN_ANALYSIS]: [CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, ADMIN],
        [statusSubCR.IN_CHECKING]: [CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, ADMIN],
        [statusSubCR.IN_PLANT_PREPARATION]: [ADMIN, VAN_CAMPAIGN_MANAGER],
      },
      [WORKFLOW_TYPE.NOT_READY]: {
        [statusSubCR.OPEN]: [CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, ADMIN],
        [statusSubCR.IN_ANALYSIS]: [CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_JV, ADMIN],
        [statusSubCR.IN_PLANT_PREPARATION]: [ADMIN, VAN_CAMPAIGN_MANAGER],
      },
    },
    [VisibilityMatrixAction.COMPLETE_SUB_CR]: {
      [WORKFLOW_TYPE.NOT_READY]: {
        [statusSubCR.IN_VAN_PLANT_COORDINATION]: [ADMIN, VAN_CAMPAIGN_MANAGER],
      },
    },
  },
};

export default matrix;
